module.exports = __webpack_public_path__ + "static/Steps-Mono-Thin-1e24435a7d3c6c17295c237b17812fd9.woff";